import React from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { useState, useEffect,useRef, useMemo} from 'react';
import './classes/ApplicantEditProfile.css';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { configData } from "../config";
import Loading from './Loading';
import SweetAlert2 from 'react-sweetalert2';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { format } from "date-fns";
import Editor from 'react-simple-wysiwyg';
import TimeInput from './TimeInput';
import { useTimezoneSelect, allTimezones } from "react-timezone-select";

const labelStyle = "original"
const timezones = {
  ...allTimezones,
  "Europe/Berlin": "Frankfurt",
  'America/Lima': 'Pittsburgh',
}

const EditAthlete = ({uid,userLoggedInRoles,userRoles,picture,userAthleteAssets}) => {
    const navigate = useNavigate();

  

  

   
 
const sportsOptions = [
  { value: "45", label: "Action Sports" },
  { value: "2", label: "Baseball" },
  { value: "3", label: "Basketball" },
  { value: "7", label: "Boxing" },
  { value: "8", label: "Cricket" },
  { value: "42", label: "Extreme Sports" },
  { value: "1", label: "Football (American)" },
  { value: "5", label: "Golf" },
  { value: "6", label: "Hockey" },
  { value: "39", label: "Motor Sports" },
  { value: "44", label: "Olympic" },
  { value: "41", label: "Other" },
  { value: "16", label: "Polo" },
  { value: "18", label: "Rodeo" },
  { value: "46", label: "Rugby" },
  { value: "4", label: "Soccer" },
  { value: "30", label: "Tennis" },
  { value: "31", label: "Track and Field" }
];
    const [formData, setFormData] = useState({   
        field_athlete_contract:[], 
        field_athelte_id:'',
        field_show_on_frontend_athlete:0,
        field_current_class:0,
        field_athlete_featured:0,
        field_available:0,
        field_show_on_smww_basketball:0,
        field_date_of_signing: {
            date: null,
            time: ''
        },
        field_signing_agent_id:'',
        field_current_agent_id:'',
        field_date_of_assignment: {
            date: null,
            time: ''
        },
        field_athlete_sports:[],
        field_athlete_position:'',
            field_dob: {
            date: null,
            time: ''
        },
        field_athlete_rank:'',
        field_tier_status:'',
        field_tier_status_date: {
            date: null,
            time: ''
        },
        field_athlete_type:'',
        field_high_school: '',
        field_hs_location: '',
        field_hs_grad_year: '',
        field_college_grad_date: '',
        field_birthday: '',
        field_reg_step: '3',
        field_hear_about_doc_talk: '',
        field_doctalk_course_month:'',
        field_athlete_height:'',
        field_height_unit:'',
        field_athlete_weight:'',
        field_weight_unit:'',       
        field_how_to_contact_client:'',
        field_q_a:'',
        picture: null,
        pictureDelete: false,
     
        uid:uid,    
        
        button_name:'Save',
      
        sport_played:'',
        specific_sport:'',
        positions_played:'',
        university_attended:'', 
        awards:'',
        test_info:'',
    });
    const[error,setError] = useState({});
    const [originalUserName, setOriginalUserName] = useState('');
    const [fieldErrors, setFieldErrors] = useState({
        userName: false
    });
    const [editorMode, setEditorMode] = useState({
        biography: true,
        education: true,
        qa: true,
        contact: true,
        careerinfo:true,
        agentBio:true,
        scoutBio:true,
        mentorbio:true,
        most_recent_seasons_stats:true,
        video_highlights:true,
    });
   
    const toggleEditor = (field) => {
        const fieldMap = {
            biography: 'field_biography',
            education: 'field_education',
            qa: 'field_q_a',
            contact: 'field_how_to_contact_client',
            careerinfo:'field_career_information',
            agentBio: 'field_agent_biography',
            scoutBio:'field_scout_biography',
            mentorbio:'field_mentor_biography',
            most_recent_seasons_stats:'field_most_recent_seasons_stats',
            video_highlights:'field_video_highlights',
        };
    
        const fieldKey = fieldMap[field];
    
        setEditorMode(prev => {
            const switchingToRich = !prev[field];
        
            setFormData(prevFormData => {
            const value = prevFormData[fieldKey] || '';
            const trimmed = value.trim();
        
            if (switchingToRich) {
                const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(trimmed);
                const hasUnwrappedText = !looksLikeHtml || /^[^<]+|[^>]+$/g.test(trimmed);
        
                if (hasUnwrappedText) {
                const wrapped = `<p>${trimmed.replace(/\n+/g, '</p><p>')}</p>`;
                return {
                    ...prevFormData,
                    [fieldKey]: wrapped,
                };
                }
        
                return prevFormData;
            } else {
                return {
                ...prevFormData,
                [fieldKey]: isEditorEmpty(value) ? '' : value,
                };
            }
            });
        
            return {
            ...prev,
            [field]: switchingToRich,
            };
        });
    };
    
    
    const isEditorEmpty = (html) => {
        const cleaned = html.trim();
        return (
            cleaned === '' ||
            cleaned === '<p><br></p>' ||
            cleaned === '<p></p>' ||
            cleaned === '<br>' ||
            cleaned === '<p><br></p><p><br></p>'
        );
    };
    
    
    
    const onEditorChange = (field, value) => {
        const cleanedValue = isEditorEmpty(value) ? '' : value;
        setFormData(prev => ({ ...prev, [field]: cleanedValue }));
    };
    
   
    const DOBRef = useRef(null);
    const DateofSigningRef = useRef(null);
    const DateofAssignRef = useRef(null);
    const TierStatusDateRef = useRef(null);
    const[success,setSuccess] = useState({});
    const [file, setFile] = useState({});
    const domain_url = configData.DOMAIN_URL;
    const app_url = configData.APP_URL;
    const loggedin_uid = localStorage.getItem('drupal_uid');
    const [swalProps, setSwalProps] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const [previewImageUrl, setPreviewImageUrl] = useState("/basic/web/images/notavailable.jpg");
    const [showDeletePictureCheckbox, setShowDeletePictureCheckbox] = useState(false);
    
   

 

    const [athleteSelectedFiles, setAthleteSelectedFiles] = useState([]);
    const [athleteUploadedFiles, setAthleteUploadedFiles] = useState([]);
    const [athleteFileInputKey, setAthleteFileInputKey] = useState(0);
    const [athleteErrorMessage, setAthleteErrorMessage] = useState('');
    const [athletecontractuploadFiles, setAthleteContractUploadedFiles] = useState([]);

    const [athleteType, setAthleteType] = useState({});
    const [athletesportList, setAthleteSportList] = useState({});
//     const [athleteAssets, setAthleteAssets] = useState([]);
useEffect(() => {
  getfieldslist();
  retrieveUserDetails();
}, []);


   

    const formatTime = (date = new Date(), withSeconds = true) => {
        const pad = (n) => String(n).padStart(2, "0");
        const hh = pad(date.getHours());
        const mm = pad(date.getMinutes());
        const ss = pad(date.getSeconds());
        return withSeconds ? `${hh}:${mm}:${ss}` : `${hh}:${mm}`;
    };
    const [initialTime, setInitialTime] = useState("");      // For HH:MM:SS
    const [initialDobTime, setInitialDobTime] = useState(""); // For HH:MM
    const [inputValue, setInputValue] = useState("");       // if you need for controlled input

    useEffect(() => {
    const now = new Date();
    setInitialTime(formatTime(now, true));   // HH:MM:SS
    setInitialDobTime(formatTime(now, false)); // HH:MM
    setInputValue(formatTime(now, true));   // Default input with HH:MM:SS
    }, []);

    const [toggles, setToggles] = useState({
       
        athleteprofile:true,
        athletedetails:true,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

   
    const handleAthleteSportChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_athlete_sports: selectedValues }));
    };
    const getCurrentDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    };
    const currentFormattedDate = getCurrentDateFormatted();

    const getCurrentBDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };
    const currentFormattedBDate = getCurrentBDateFormatted();  
    
const parseDate = (dateString) => {
    if (!dateString) return null;

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [mm, dd, yyyy] = dateString.split('/');
        dateString = `${yyyy}-${mm}-${dd}`;
    }
    const dateObj = new Date(dateString);
    return isNaN(dateObj) ? null : dateObj;
};

useEffect(() => {
        const processData = () => {
            // Check the correct prop name here
            if (!userAthleteAssets || userAthleteAssets.length === 0) return;

            setFormData(prev => {
                const updated = { ...prev };

                userAthleteAssets.forEach(item => {
    if (item.key === 'field_athlete_contract') {
        setAthleteContractUploadedFiles(item['full_value'] || []);
    } else if (
        ['field_date_of_assignment', 'field_date_of_signing', 'field_tier_status_date', 'field_dob'].includes(item.key)
    ) {
        updated[item.key] = {
            date: item.date ? parseDate(item.date) : null,
            time: item.time || '',
        };
    } 
    // --- ADD THIS SPECIFIC CASE ---
    else if (item.key === 'field_athlete_sports') {
        // Use item.value because it contains the ID array ["2"]
        // Ensure it's always an array so the 'multiple' select works
        updated[item.key] = Array.isArray(item.value) ? item.value : (item.value ? [item.value] : []);
    } 
    else if (item.key === 'field_signing_agent_id' || item.key === 'field_current_agent_id') {
        updated[item.key] = item.value ?? item.full_value ?? '';
    } 
    // ------------------------------
    else {
        updated[item.key] = item.full_value ?? item.value ?? '';
    }
});
                return updated;
            });
            
            // Only stop loading once we have actually processed the data
            setIsLoading(false);
        };

        processData();
    }, [userAthleteAssets]);

//  async function getathletedetails() { 
//   if (uid !== '' || username !== '') {
//     try {
//       setIsLoading(true);

//       const response = await fetch(
//         app_url + 'viewprofile/getathletedetails?uid=' + uid
//       );

//       const responsedata = await response.json();

//       if (responsedata.data.result === "Success") {
//         setAthleteAssets(responsedata.data.user_athlete_assets || []);
//         setSocialAssets(responsedata.data.user_social_media_assets || {});
//         setCommonAssets(responsedata.data.user_common_assets || {});
//       }

//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   }
// }

  async function retrieveUserDetails() {
    if(uid) {
       try {
        
    const response = await fetch(
      app_url+'editprofile/getusereditdetails?uid='+uid,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {




    if (responsedata.data.result) {
        setOriginalUserName(responsedata.data.result.userName || "");
        setFormData(prevState => {
            const updated = { ...prevState };

            Object.keys(responsedata.data.result).forEach(key => {
            const value = responsedata.data.result[key];

            if (key === 'field_recent_graduation_date' && value) {
                updated[key] = parseDate(value);
            } else {
                updated[key] = value ?? '';
            }
            });

            return updated;
        });
    }
    // if(responsedata.data.sortflags) {
    //  setSortFlagOptions(responsedata.data.sortflags);
    // }
    //  if(responsedata.data.courses) {
    //  setCourseList(responsedata.data.courses);
    // }
    console.log(formData);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  }
  }
 
   async function getfieldslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwfieldlist/getfieldlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
               setAthleteType(responsedata.data.athletetype);
               setAthleteSportList(responsedata.data.athletesport);
            //    setLeadList(responsedata.data.leadtype);
            //    setSportsFocus(responsedata.data.sportsfocus);
            //    setSportsYouWorked(responsedata.data.sportsworked);
            //    setDreamJob(responsedata.data.dreamjob);
            } 
        } catch (err) {
            
         }
        
  }
 

   
   
    const validateForm = (data) => {
        const errors = [];
        const newFieldErrors = { field_athlete_height: false , field_athlete_weight: false }; 
        



 
  // Height
  if (data.field_height_unit === 'Imperial') {
    if (!data.field_athlete_height) {
     errors.push("Please enter height in feet and inches.");
  newFieldErrors.field_athlete_height = true;
    }
  } else if (data.field_height_unit === 'Metric') {
    if (!data.field_athlete_height) {
     errors.push("Please enter height in cm.");
  newFieldErrors.field_athlete_height = true;
    }
  }

 //weight
  if (data.field_weight_unit === 'lb') {
    if (!data.field_athlete_weight) {
     errors.push("Please enter your weight.");
  newFieldErrors.field_athlete_weight = true;
    }
  } else if (data.field_weight_unit === 'kg') {
    if (!data.field_athlete_weight) {
     errors.push("Please enter your weight.");
  newFieldErrors.field_athlete_weight = true;
    }
  }      
          

       
        return errors; 
    } 
  

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            const arrayFields = [
                "applied_courses",
                "sort_flags",
                "field_lead_type",
                "field_agent_sports",
                "field_agent_certifications",
                "field_special_certifications",
                "field_scout_sport",
                "field_cuc_degrees",
                "field_doc_talk",
                "field_mentor_sports"
            ];

            if (arrayFields.includes(name)) {
            setFormData((prev) => {
                let current = [...(prev[name] || [])].map(String);
                const stringValue = String(value);

                if (checked && !current.includes(stringValue)) {
                current.push(stringValue);
                } else if (!checked) {
                current = current.filter((item) => item !== stringValue);
                }

                return {
                ...prev,
                [name]: current,
                };
            });

            return;
            }

            // Boolean fields
            setFormData((prev) => ({
            ...prev,
            [name]: checked ? 1 : 0,
            }));

            return;
        }

        // Non-checkbox fields
        // if (name === "password") {
        //     setPasswordStrength(calculatePasswordStrength(value));
        // }

        setFormData((prev) => {
            const updated = { ...prev };

            if (name.includes(".")) {
            const [parent, child] = name.split(".");
            let finalValue = value;

            if (name === "field_dob.time" && value?.length >= 5) {
                finalValue = value.substring(0, 5);
            }

            updated[parent] = {
                ...prev[parent],
                [child]: finalValue,
            };
            } else {
            updated[name] = value;
            }

            return updated;
        });
    };
  

const fileInputRef = useRef();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const errors = [];

        if (!file.type.startsWith("image/")) {
            errors.push("Only files with the following extensions are allowed: png, gif, jpg, jpeg.");
            e.target.value = null;
            showErrors(errors);
            return;
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 100 || height < 100) {
            errors.push("Image is too small. Minimum size is 100×100 pixels.");
            }

            if (width > 1000 || height > 1000) {
            errors.push("Image is too large. Maximum size is 1000×1000 pixels.");
            }

            // URL.revokeObjectURL(objectUrl);

            if (errors.length > 0) {
            e.target.value = null;
            showErrors(errors);
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
            }

            // Valid file: update state
            setFile(file);
            setPreviewImageUrl(objectUrl);
            // setShowDeletePictureCheckbox(true);

            setFormData((prev) => ({
            ...prev,
            picture: file,
            pictureDelete: false, // Reset delete checkbox if a new file is selected
            }));
        };

        img.onerror = () => {
            errors.push("Failed to load image. Please choose a valid image file.");
            e.target.value = null;
            URL.revokeObjectURL(objectUrl);
            showErrors(errors);
        };

        img.src = objectUrl;
    };

useEffect(() => {
  if (picture) {
    setPreviewImageUrl(picture);
    setShowDeletePictureCheckbox(true);
  } else {
    setPreviewImageUrl("/basic/web/images/notavailable.jpg");
  }
  console.log(formData);
}, [picture]);

    const showErrors = (errors) => {
        setError(errors); 
        setSuccess({});
        window.scrollTo(0, 0);
    };

    const handleDeleteCheckboxChange = (e) => {
        const isChecked = e.target.checked;

        setFormData((prev) => ({
            ...prev,
            pictureDelete: isChecked,
            picture: isChecked ? null : prev.picture,
        }));

        if (isChecked) {
            setFile(null);
            setPreviewImageUrl("/basic/web/images/notavailable.jpg");
            // setShowDeletePictureCheckbox(false);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    };

    const handleUserRoleFileChange = (e, setTempImageCallback, setImageRemovedCallback, setErrorCallback) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024; // 128 MB
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 100 || height < 100 || width > 1000 || height > 1000) {
                errors.push('Image size must be 100×100 px or 1000×1000 px.');
            }

            URL.revokeObjectURL(objectUrl);

            if (errors.length > 0) {
                setErrorCallback?.(errors.join('<br />'));
                e.target.value = '';
                setTempImageCallback(null);
            } else {
                setTempImageCallback(file);      
                setErrorCallback?.(null);         
                setImageRemovedCallback?.(false);
            }
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            setErrorCallback?.('Failed to load image. Please choose a valid image file.');
            e.target.value = '';
            setTempImageCallback(null);
        };

        img.src = objectUrl;
    };

   
const handleSubmit = async event => {
  event.preventDefault();
  const newErrors = validateForm(formData);
  setError(newErrors);
  setSuccess({});
   if (Object.keys(newErrors).length === 0) {
let finalFormData = { 
        ...formData,
        // Ensure this key exists so the backend doesn't crash
        placements: formData.placements || [] 
    };
    // Helper function to format date and time fields
    const formatDate = (date) => {
        if (typeof date === 'string') {
            date = date.trim();
        }
        if (date instanceof Date) {
            return format(date, 'yyyy-MM-dd');
        }
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date;
        }
        if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
            const [dd, mm, yyyy] = date.split('-');
            return `${yyyy}-${mm}-${dd}`;
        }
        throw new Error(`Invalid date format: ${date}`);
    };

    const formatDateTimeField = (field) => {
        const fieldData = finalFormData[field];
        if (!fieldData?.date) {
            finalFormData[field] = '';
            return;
        }
        let formattedValue = formatDate(fieldData.date);
        if (fieldData.time) {
            formattedValue += ` ${fieldData.time}`;
        }
        finalFormData[field] = formattedValue;
    };

    // Apply formatting to all relevant fields
    formatDateTimeField('field_date_of_signing');
    formatDateTimeField('field_date_of_assignment');
    formatDateTimeField('field_dob');
    formatDateTimeField('field_tier_status_date');

    finalFormData.field_recent_graduation_date =
    finalFormData.field_recent_graduation_date
    ? formatDate(finalFormData.field_recent_graduation_date)
    : '';

 

    setFormData(prevState => ({
      ...prevState,
      button_name: "Saving..."
    }));

    const postData = new FormData();
    postData.append("file", file);

    athleteUploadedFiles.forEach(file => postData.append('athletecontractfiles[]', file)); 
    postData.append("formData", JSON.stringify(finalFormData));

    const response = await fetch(app_url + "editprofile/putuserathleteeditdetails", {
      method: "POST",
      body: postData,
    });

    const data = await response.json();

    if (data.data.msg === "Success") {
      retrieveUserDetails();
     // setSuccess(data.data.result);

    //   setFormData(prevState => ({
    //     ...prevState,
    //     button_name: "Save"
    //   }));
       navigate(`/user/${uid}/athlete`, {
                state: {
                result: data.data.result,
                }
            });
      window.scrollTo(0, 0);
    } else {
      setError(data.data.result);
      setSuccess({});
      setFormData(prevState => ({
        ...prevState,
        button_name: "Save"
      }));
      window.scrollTo(0, 0);
    }
  }
   else {
    window.scrollTo(0, 0);
  }
};

    const validTypes = [
        'text/plain',
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
    ];

    const maxSize = 128 * 1024 * 1024;

const getFileIcon = (fileName) => {
  if (!fileName || typeof fileName !== 'string') {
    return '/basic/web/images/image-x-generic.png';
  }

  const extension = fileName.split('.').pop().toLowerCase();

  switch (extension) {
    case 'txt': return '/basic/web/images/text-plain.png';
    case 'pdf': return '/basic/web/images/application-pdf.png';
    case 'docx': return '/basic/web/images/x-office-document.png';
    case 'jpg':
    case 'jpeg':
    case 'png': return '/basic/web/images/image-x-generic.png';
    default: return '/basic/web/images/image-x-generic.png';
  }
};

    const handleFileInputChange = (e, setSelected, setError, setKey) => {
        const files = Array.from(e.target.files);

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;

            if (isValidType && isValidSize) {
            validFiles.push(file);
            } else {
            invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setError(
            `The selected file${invalidFiles.length > 1 ? 's' : ''} ${names} cannot be uploaded. 
            Only files with the following extensions are allowed: txt, png, jpg, jpeg, pdf, docx.`
            );
            setKey(prev => prev + 1); // reset input
            setSelected([]);          // clear selection
        } else {
            setError('');
            setSelected(validFiles);
        }
    };
    const handleUpload = (selectedFiles, setUploaded, setError, setSelected, setKey) => {
        const newFiles = selectedFiles.filter(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;
            return isValidType && isValidSize;
        });

        setUploaded(prev => [...prev, ...newFiles]);
        setError('');
        setSelected([]);
        setKey(prev => prev + 1); // reset input
    };
    const removeFile = (index, setUploaded) => {
        setUploaded(prev => prev.filter((_, i) => i !== index));
    };

     const removeAthleteContractFile = (index,removed_fid) => {
        setAthleteContractUploadedFiles(prev => prev.filter((_, i) => i !== index));
         setFormData(prev => ({
    ...prev,
    removed_athlete_contract_fids: [...(prev.removed_fids || []), removed_fid]
  }));
    };

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : (
        <div className="Applicantedit-profile-container">
            {error.length > 0 && (
                    <div 
                        className="set-message-error" 
                        style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, padding: "10px 10px 10px 50px"}}
                    >
                    {error.map((item, index) => {
                    return <>{item}<br /></>
                    
                    })}  
                </div>
            )}
            {success.length > 0 && (
                <>
                    {success.map((item, index) => {
                        return <>
                        <br/><div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {item}
                        </div></>
                    
                    })}  
                </>
            )}
            <SweetAlert2 {...swalProps} />
            {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                <form onSubmit={handleSubmit}>          
                    <>
                               <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("athleteprofile")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Athlete Profile</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.athleteprofile ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.athleteprofile && (
                                <>
                        {/* <div className="field-row">
                        <span class='label'><label htmlFor="edit-submitted-sport-played">
                          Sport Played 
                        </label></span>  
                        <span class='value'>
                        <select
                          id="edit-submitted-sport-played"
                          name="sport_played"
                          value={formData.sport_played} 
                          onChange={handleChange}
                        >
                            <option value="">- Select -</option>

                        {sportsOptions.map((sport) => (
                            <option key={sport.value} value={sport.value}>
                            {sport.label}
                            </option>
                        ))}

                        </select></span> 
                      </div> */}
                       
                        {/* <div className="field-row">
                        <span class='label'><label htmlFor="edit-submitted-positions-played">Primary Position </label></span>
                        <span class='value'>
                        <input 
                            type="text" 
                            id="edit-submitted-positions-played" 
                            name="positions_played" 
                            value={formData.positions_played} 
                            size="60"  
                            maxLength={128}
                            onChange={handleChange}
                        /></span>
                        </div> */}
                        
                               

                                    <div className="field-row">
                                        <span class='label'><label htmlFor="edit-field-athlete-sport">Athlete Sport</label></span>
                                        <span class='value'>
                                        <select 
                                            id="edit-field-athlete-sport" 
                                            name="field_athlete_sports" 
                                            value={formData.field_athlete_sports}
                                            onChange={handleAthleteSportChange}
                                            multiple
                                            size={8}
                                            style={{width:"300px"}}
                                            className=""
                                        >
                                            <option value="_none">- None -</option>
                                            {Object.entries(athletesportList).map(([value, label]) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </select></span>
                                    </div>
                                    <div className="field-row">
                                        <span class='label'><label>Athlete Position</label></span>
                                        <span class='value'>
                                        <textarea
                                            name="field_athlete_position"
                                            value={formData.field_athlete_position}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" style={{
                                            background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                        }}></div></span>
                                    </div>
                                <div className='field-row'>
                                    <span class='label'>DOB </span> 
                                     <span class='value'>
                                    <fieldset className=''>
                                        
                                      
                                        <div className="call-back-container">
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="date_of_birth">Date</label>
                                                <DatePicker
                                                    ref={DOBRef}
                                                    name="field_dob.date"
                                                    selected={formData.field_dob?.date}
                                                    onChange={(date) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            field_dob: {
                                                            ...prev.field_dob,
                                                            date: date,
                                                            },
                                                        }));
                                                        setTimeout(() => {
                                                            const input = DOBRef.current?.input;
                                                            if (input) {
                                                            const len = input.value.length;
                                                            input.setSelectionRange(len, len);
                                                            }
                                                        }, 0);
                                                    }}
                                                    dateFormat="yyyy-MM-dd"
                                                    //placeholderText={currentFormattedDate}
                                                    id="date_of_birth"
                                                />
                                                <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                            </div>
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="edit-field-call-back-day">Time </label>
                                                <div className="call-back-field">
                                                    {/* DOB → HH:MM */}
                                                    <TimeInput
                                                        name="field_dob.time"
                                                        value={formData.field_dob?.time}
                                                        onChange={handleChange}
                                                        //placeholder={initialDobTime}   // HH:MM
                                                        format="HH:mm"                 // only if TimeInput supports this prop
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {initialDobTime}</span>
                                                </div>
                                            </div>              
                                        </div>
                                    </fieldset></span>
                                </div>
                              
                                <div className="field-row">
                                    <span class='label'>
                                    <label htmlFor="edit-field-athlete-type">Athlete Type</label></span>
                                     <span class='value'>
                                    <select 
                                        className="" 
                                        id="edit-field-athlete-type" 
                                        name="field_athlete_type"
                                        value={formData.field_athlete_type}
                                        onChange={handleChange}
                                    >
                                        <option value="_none">- None -</option>
                                        {Object.entries(athleteType).map(([value, label]) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </select></span>
                                </div>
                                <div className="field-row">
                                    <span class='label'><label for="edit-field-athlete-height">Athlete height </label></span>
                                     <span class='value'><input class="text-full form-text" type="text" id="edit-field-athlete-height" name="field_athlete_height" value={formData.field_athlete_height} size="60" maxlength="255" onChange={handleChange}/></span>
                                </div>
                                <div className="edit-profile-row-multi-input field-row">
                                    <span class='label'><label>Height unit</label></span>
                                    <span class='value'>
                                    <div className="edit-profile-radio-group">
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_height_unit"
                                                value="_none"
                                                checked={formData.field_height_unit === '_none'}
                                                onChange={handleChange}
                                            /> 
                                            N/A
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_height_unit"
                                                value="Imperial"
                                                checked={formData.field_height_unit === 'Imperial'}
                                                onChange={handleChange}
                                            />   
                                            Imperial
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_height_unit"
                                                value="Metric"
                                                checked={formData.field_height_unit === 'Metric'}
                                                onChange={handleChange}
                                            /> 
                                            Metric
                                        </label>
                                    </div></span>
                                </div>
                                <div className="field-row">
                                    <span class='label'><label for="edit-field-athlete-weight">Athlete weight </label></span>
                                    <span class='value'><input class="text-full form-text" type="text" id="edit-field-athlete-weight" name="field_athlete_weight" value={formData.field_athlete_weight} size="60" maxlength="255" onChange={handleChange}/></span>
                                </div>
                                <div className="edit-profile-row-multi-input field-row">
                                    <span class='label'><label>Weight unit </label></span>
                                    <span class='value'>
                                    <div className="edit-profile-radio-group">
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_weight_unit"
                                                value="_none"
                                                checked={formData.field_weight_unit === '_none'}
                                                onChange={handleChange}
                                            /> 
                                            N/A
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_weight_unit"
                                                value="lb"
                                                checked={formData.field_weight_unit=== 'lb'}
                                                onChange={handleChange}
                                            />   
                                            lb
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_weight_unit"
                                                value="kg"
                                                checked={formData.field_weight_unit === 'kg'}
                                                onChange={handleChange}
                                            /> 
                                            kg
                                        </label>
                                    </div></span>
                                </div>
                                </>
                            )}
                        </fieldset> 
                            <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("athletedetails")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Athlete Details</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.athletedetails ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.athletedetails && (
                                <>
                                 {/* <div className="field-row">
                                    <span class='label'><label htmlFor="edit-submitted-specific-sport">Specific Sport </label></span>
                                    <span class='value'>                          
                                    <input 
                                        type="text" 
                                        id="edit-submitted-specific-sport" 
                                        name="specific_sport" 
                                        value={formData.specific_sport} 
                                        size="60"  
                                        maxLength={128}
                                        onChange={handleChange}
                                    />  </span>
                                    </div>
                                     <div className="field-row">
                        <span class='label'><label htmlFor="edit-submitted-university-attended">University Attended </label></span>
                         <span class='value'>
                        <input 
                            type="text" 
                            id="edit-submitted-university-attended" 
                            name="university_attended" 
                            value={formData.university_attended} 
                            size="60"  
                            maxLength={128}
                            onChange={handleChange}
                        /></span>
                        </div>
                           <div className="field-row">
                           <span class='label'><label htmlFor="edit-submitted-awards">Awards </label></span>
                           <span class='value'>
                          <div>
                               <textarea
                                    className="form-textarea-wrapper resizable textarea-processed resizable-textarea form-textarea"
                                    type="text"
                                    id="edit-submitted-awards"
                                    name="awards"
                                    cols={60}
                                    rows={5}
                                    value={formData.awards}
                                    onChange={handleChange}
                                  ></textarea>
                              <div className="grippie" style={{
                                background: `#eee url(${process.env.PUBLIC_URL}/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                          </div></span>
                      </div>
                        <div className="field-row">
                          <span class='label'><label htmlFor="edit-submitted-test-info">Test Info (40 time, 60 time, arm speed etc.) </label></span>
                           <span class='value'>
                          <div>
                               <textarea
                                    className="form-textarea-wrapper resizable textarea-processed resizable-textarea form-textarea"
                                    type="text"
                                    id="edit-submitted-test-info"
                                    name="test_info"
                                    cols={60}
                                    rows={5}
                                    value={formData.test_info}
                                    onChange={handleChange}
                                  ></textarea>
                              <div className="grippie" style={{
                                background: `#eee url(${process.env.PUBLIC_URL}/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                          </div></span>
                      </div> */}
                       <div className="field-row">
                                    <span class='label'><label for="edit-field-athelte-id">Athlete ID # </label></span>
                                    <span class='value'><input type="text" id="edit-field-athelte-id" name="field_athelte_id" value={formData.field_athelte_id} size="12" maxlength="10" className="form-text" onChange={handleChange} readOnly disabled/></span>
                                </div>
                                 {/* Athlete Contract */}
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || 
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && (
                        <div className="field-row">
                            <span class='label'>Athlete Contract</span>
                            <span class='value'>
                            <fieldset>
                            <div>
                                {(athleteUploadedFiles?.length > 0 || athletecontractuploadFiles?.length > 0) && (
                                <table className='scout-section-table' style={{fontSize:"14px", width:"100%", display: "table"}}>
                                    <thead>
                                    <tr style={{textAlign:"left"}}>
                                        <th>File information</th>
                                        <th>Operations</th>
                                    </tr>
                                    </thead>
                                    <tbody style={{backgroundColor: "#eee"}}>
                                    
                                    {athleteUploadedFiles.length > 0 &&  athleteUploadedFiles.map((file, index) => (
                                        <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                        <td>
                                            <span>
                                            <img
                                                alt="File icon"
                                                src={getFileIcon(file.name)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                {file.name}
                                            </a>
                                            </span>
                                            <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                        </td>
                                        <td>
                                            <button
                                            type="button"
                                            className="form-submit"
                                            onClick={() => removeFile(index, setAthleteUploadedFiles)}
                                            >
                                            Remove
                                            </button>
                                        </td>
                                        </tr>
                                    ))}
                                    {athletecontractuploadFiles && athletecontractuploadFiles.length > 0 && athletecontractuploadFiles.map((file, index) => (
                                        <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                        <td>
                                            <span>
                                            <img
                                                alt="File icon"
                                                src={getFileIcon(file.name)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <a href={file.url} target="_blank" rel="noreferrer">
                                                {file.name}
                                            </a>
                                            </span>
                                            <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                        </td>
                                        <td>
                                            <button
                                            type="button"
                                            className="form-submit"
                                            onClick={() => removeAthleteContractFile(index,file.fid)}
                                            
                                            >
                                            Remove
                                            </button>
                                        </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                )}

                                
                                {athleteErrorMessage && (
                                <div 
                                    className="set-message-error" 
                                    style={{ 
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                    padding: "10px 10px 10px 50px",
                                    width: "90%",
                                    }}
                                >
                                    {athleteErrorMessage}
                                </div>
                                )}
                                <div className="form-item">
                                <label htmlFor="edit-field-athlete-contract">Add a new file</label>
                                <div>
                                    <input
                                    type="file"
                                    id="edit-field-athlete-contract"
                                    name="field_athlete_contract"
                                    multiple
                                    onChange={(e) => handleFileInputChange(e, setAthleteSelectedFiles, setAthleteErrorMessage, setAthleteFileInputKey)}
                                    key={athleteFileInputKey}
                                    style={{width: "auto"}}
                                    />
                                    <button type="button" onClick={() => handleUpload(athleteSelectedFiles, setAthleteUploadedFiles, setAthleteErrorMessage, setAthleteSelectedFiles, setAthleteFileInputKey)} disabled={athleteSelectedFiles.length === 0} className="form-submit">
                                    Upload
                                    </button>
                                </div>
                                <div className="description">
                                    Files must be less than <strong>128 MB</strong>.<br />
                                    Allowed file types: <strong>txt, png, jpg, jpeg, pdf, docx</strong>.
                                </div>
                                </div>
                                        </div>
                                    </fieldset></span>
                                </div>)}
                                <div className="edit-profile-common-checkbox field-row">
                                    <div className='value'>
                                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || 
                                        userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && (
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="show-on-frontend-athlete"
                                            name="field_show_on_frontend_athlete"
                                            value = "1" 
                                            defaultChecked={formData.field_show_on_frontend_athlete == "1" ? "true" : ""}                      
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="show-on-frontend-athlete">Show On Frontend Athlete </label>
                                        </div>
                                        )}
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="field-current-class"
                                            name="field_current_class"
                                            value = "1" 
                                            defaultChecked={formData.field_current_class == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="field-current-class">Current Class </label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="athlete-featured"
                                            name="field_athlete_featured"
                                            value = "1" 
                                            defaultChecked={formData.field_athlete_featured == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="athlete-featured">Athlete Featured </label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="available"
                                            name="field_available"
                                            value = "1" 
                                            defaultChecked={formData.field_available == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="available">Available </label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="smww-basketball"
                                            name="field_show_on_smww_basketball"
                                            value = "1" 
                                            defaultChecked={formData.field_show_on_smww_basketball == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="smww-basketball">Show on SMWW Basketball </label>
                                        </div>
                                    </div>
                                </div>
                                    <div className='field-row'>
                                        <span class='label'>DATE OF SIGNING</span>
                                        <span class='value'>
                                        <fieldset className=''>
                                           
                                            <div className="call-back-container">
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_signing_date">Date</label>
                                                    <DatePicker
                                                        ref={DateofSigningRef}
                                                        name="field_date_of_signing.date"
                                                        selected={formData.field_date_of_signing?.date}
                                                        onChange={(date) => {
                                                            setFormData((prev) => ({
                                                            ...prev,
                                                            field_date_of_signing: {
                                                                ...prev.field_date_of_signing,
                                                                date: date,
                                                            },
                                                            }));
                                                            setTimeout(() => {
                                                            const input = DateofSigningRef.current?.input;
                                                            if (input) {
                                                                const len = input.value.length;
                                                                input.setSelectionRange(len, len);
                                                            }
                                                            }, 0);
                                                        }}
                                                        dateFormat="yyyy-MM-dd"
                                                        //placeholderText={currentFormattedDate}
                                                        id="date_of_signing"
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                                </div>
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_signing_time">Time </label>
                                                    <div className="call-back-field">
                                                        <TimeInput
                                                            name="field_date_of_signing.time"
                                                            value={formData.field_date_of_signing?.time}
                                                            onChange={handleChange}
                                                            //placeholder={initialTime}
                                                        />
                                                        <span className='edit-profile-desc'>Eg., {initialTime}</span>
                                                    </div>
                                                </div>              
                                            </div>
                                        </fieldset></span>
                                    </div>
                                    <div className="field-row">
                                        <span class='label'><label>Signing Agent ID</label></span>
                                        <span class='value'>
                                        <input
                                            type="text"
                                            name="field_signing_agent_id"
                                            value={formData.field_signing_agent_id}
                                            onChange={handleChange}
                                            maxLength={10}
                                            size={12}
                                        /></span>
                                    </div>
                                    <div className="field-row">
                                        <span class='label'><label>Current Agent ID</label></span>
                                        <span class='value'>
                                        <input
                                            type="text"
                                            name="field_current_agent_id"
                                            value={formData.field_current_agent_id}
                                            onChange={handleChange}
                                            maxLength={10}
                                            size={12}
                                        /></span>
                                    </div>
                                    <div className='field-row'>
                                         <span class='label'>DATE OF ASSIGNMENT</span>
                                           <span class='value'>
                                        <fieldset className=''>
                                           
                                            <div className="call-back-container">
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_assign_date">Date</label>
                                                    <DatePicker
                                                        ref={DateofAssignRef}
                                                        name="field_date_of_assignment.date"
                                                        selected={formData.field_date_of_assignment?.date}
                                                        onChange={(date) => {
                                                            setFormData((prev) => ({
                                                            ...prev,
                                                            field_date_of_assignment: {
                                                                ...prev.field_date_of_assignment,
                                                                date: date,
                                                            },
                                                            }));
                                                            setTimeout(() => {
                                                            const input = DateofAssignRef.current?.input;
                                                            if (input) {
                                                                const len = input.value.length;
                                                                input.setSelectionRange(len, len);
                                                            }
                                                            }, 0);
                                                        }}
                                                        dateFormat="yyyy-MM-dd"
                                                        //placeholderText={currentFormattedDate}
                                                        id="date_of_assign"
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                                </div>
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_assign_time">Time </label>
                                                    <div className="call-back-field">
                                                        <TimeInput
                                                            name="field_date_of_assignment.time"
                                                            value={formData.field_date_of_assignment?.time}
                                                            onChange={handleChange}
                                                            //placeholder={initialTime}
                                                        />
                                                        <span className='edit-profile-desc'>Eg., {initialTime}</span>
                                                    </div>
                                                </div>              
                                            </div>
                                        </fieldset></span>
                                    </div>
                                      <div className="field-row">
                                    <span class='label'><label>Athlete Rank</label></span>
                                    <span class='value'>
                                    <input
                                        type="text"
                                        name="field_athlete_rank"
                                        value={formData.field_athlete_rank}
                                        onChange={handleChange}
                                        maxLength={10}
                                        size={12}
                                    /></span>
                                </div>
                                <div className="field-row">
                                    <span class='label'><label>Tier Status</label></span>
                                    <span class='value'><input
                                        type="text"
                                        name="field_tier_status"
                                        value={formData.field_tier_status}
                                        onChange={handleChange}
                                        maxLength={10}
                                        size={12}
                                    /></span>
                                </div>
                                <div className="field-row">
                                      <span class='label'>TIER STATUS DATE </span>
                                       <span class='value'>
                                    <fieldset className=''>
                                       
                                        <div className="call-back-container">
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="date_of_tier_status">Date</label>
                                                <DatePicker
                                                    ref={TierStatusDateRef}
                                                    name="field_tier_status_date.date"
                                                    selected={formData.field_tier_status_date?.date}
                                                    onChange={(date) => {
                                                        setFormData((prev) => ({
                                                        ...prev,
                                                        field_tier_status_date: {
                                                            ...prev.field_tier_status_date,
                                                            date: date,
                                                        },
                                                        }));
                                                        setTimeout(() => {
                                                        const input = TierStatusDateRef.current?.input;
                                                        if (input) {
                                                            const len = input.value.length;
                                                            input.setSelectionRange(len, len);
                                                        }
                                                        }, 0);
                                                    }}
                                                    dateFormat="yyyy-MM-dd"
                                                   // placeholderText={currentFormattedDate}
                                                    id="date_of_tier_status"
                                                />
                                                <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                            </div>
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="edit-field-call-back-day">Time </label>
                                                <div className="call-back-field">
                                                    <TimeInput
                                                        name="field_tier_status_date.time"
                                                        value={formData.field_tier_status_date?.time}
                                                        onChange={handleChange}
                                                       // placeholder={initialTime}
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {initialTime}</span>
                                                </div>
                                            </div>              
                                        </div>
                                    </fieldset></span>
                                </div>

                                </>)}</fieldset>
                      <div className="edit-profile-buttons">
                        <span><button className='edit-profile-submit-button' type="submit">{formData.button_name}</button></span>
                    </div>
                     </>
                </form>
            ) : (
                <><p>You are not authorized</p></>   
            )}
        </div>
        )}
        </>
    );
    };

    export default EditAthlete;